import { Helmet } from 'react-helmet-async'

const StructuredData = () => {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://rdsstudio.co.za/#website",
    "name": "RDS Studio",
    "url": "https://rdsstudio.co.za",
    "publisher": {
      "@id": "https://rdsstudio.co.za/#organization"
    },
    "inLanguage": "en-ZA",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://rdsstudio.co.za/blog?search={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  }

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "@id": "https://rdsstudio.co.za/#organization",
    "name": "RDS Studio",
    "alternateName": "Responsive Design Solutions Studio",
    "url": "https://rdsstudio.co.za",
    "logo": {
      "@type": "ImageObject",
      "url": "https://rdsstudio.co.za/images/logo/rds-logo.png",
      "width": 600,
      "height": 600,
      "caption": "RDS Studio Logo"
    },
    "image": "https://rdsstudio.co.za/images/logo/og-image.png",
    "description": "Leading digital marketing agency in Centurion offering professional web design, SEO, and custom development services. With 10+ years experience, our expert team delivers custom WordPress websites, Google Ads campaign management, React applications, and private cloud infrastructure solutions to South African businesses.",
    "foundingDate": "2014",
    "telephone": "+27846390621",
    "email": "info@rdsstudio.co.za",
    "sameAs": [
      "https://www.facebook.com/profile.php?id=61579996723546",
      "https://www.instagram.com/rdsstudio1111/",
      "https://www.linkedin.com/in/jean-pierre-matthys-du-toit-7671493a3/",
      "https://www.youtube.com/channel/UCqEgC_kMwk4MqEcIC_yCayw"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+27846390621",
      "contactType": "Customer Service",
      "email": "info@rdsstudio.co.za",
      "hoursAvailable": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      "areaServed": ["Centurion", "Pretoria", "Midrand", "Johannesburg", "Gauteng"],
      "availableLanguage": ["English", "Afrikaans"]
    }
  }

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://rdsstudio.co.za/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Services",
        "item": "https://rdsstudio.co.za/services"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Portfolio",
        "item": "https://rdsstudio.co.za/portfolio"
      },
      {
        "@type": "ListItem",
        "position": 4,
        "name": "Blog",
        "item": "https://rdsstudio.co.za/blog"
      },
      {
        "@type": "ListItem",
        "position": 5,
        "name": "Contact",
        "item": "https://rdsstudio.co.za/contact"
      }
    ]
  }

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Who is the best web designer in Centurion?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "RDS Studio is a top-rated web design agency based in Centurion, Gauteng. With 10+ years experience delivering custom WordPress sites, SEO & digital marketing for businesses across Centurion, Pretoria and Gauteng, we’re the trusted local choice for professional web design."
        }
      },
      {
        "@type": "Question",
        "name": "How much does web design cost in Centurion?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Web design pricing in Centurion varies by project. At RDS Studio, a basic WordPress business website starts from R8,500. Custom web applications and e-commerce stores range from R25,000 upward. Contact us for a free, no-obligation quote tailored to your business needs."
        }
      },
      {
        "@type": "Question",
        "name": "Do you offer web design services near me in Centurion?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! RDS Studio is based in Centurion and serves clients throughout Centurion, Pretoria, Midrand, Irene, Lyttelton, The Reeds, Highveld and across Gauteng. We offer in-person meetings for local clients and remote collaboration for those further afield."
        }
      },
      {
        "@type": "Question",
        "name": "What web design services does RDS Studio offer in Centurion?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "RDS Studio offers full web design and digital services in Centurion: custom WordPress website design & development, WooCommerce e-commerce, SEO optimisation, Google Ads & Meta Ads management, social media marketing, custom CMS development, private cloud hosting, and ongoing website maintenance."
        }
      },
      {
        "@type": "Question",
        "name": "How long does it take to build a website in Centurion?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "At RDS Studio, a simple WordPress business website takes 2–3 weeks. A custom business website with custom features takes 4–6 weeks. Complex web applications or e-commerce platforms take 8–12 weeks. We’ll give you a clear timeline before we start."
        }
      },
      {
        "@type": "Question",
        "name": "Will my website rank on Google?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Every website RDS Studio builds includes on-page SEO, fast load speeds, mobile-first design, structured data, and proper meta tags — all factors Google uses to rank websites. We also offer ongoing SEO services from R4,500/month to actively improve your Google rankings."
        }
      },
      {
        "@type": "Question",
        "name": "Where is RDS Studio located?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "RDS Studio is based in Centurion, Gauteng, South Africa (postal code 0157). We serve businesses in Centurion, Pretoria, Midrand, Johannesburg, and across South Africa. In-person meetings are available for clients in the Centurion and Pretoria area."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide ongoing website support and maintenance?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, RDS Studio offers website maintenance packages including security updates, regular backups, performance monitoring, and content updates. Plans start from R500/month depending on your requirements."
        }
      },
      {
        "@type": "Question",
        "name": "What is professional web design and why does it matter?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Professional web design means creating a website that is visually impressive, technically sound, mobile-first, fast-loading, and built around your business goals. A professionally designed website builds trust with potential customers, ranks better on Google, and converts more visitors into paying clients. RDS Studio delivers professional web design from R8,500 for Centurion and Gauteng businesses."
        }
      },
      {
        "@type": "Question",
        "name": "What does a professional web design agency in Centurion do?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "A professional web design agency like RDS Studio in Centurion handles everything from custom design and WordPress development to SEO, Google Ads, and ongoing website maintenance. We manage the full digital presence of your business — from your first professional website to ongoing marketing campaigns that drive leads and sales."
        }
      },
      {
        "@type": "Question",
        "name": "How do I choose a professional web designer near me in Centurion?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "When choosing a professional web designer near you in Centurion, look for a portfolio of real projects, transparent pricing, local knowledge, and a team that communicates clearly. RDS Studio has been designing professional websites for Centurion and Gauteng businesses since 2014. View our portfolio at rdsstudio.co.za/portfolio or call +27 84 639 0621 for a free quote."
        }
      },
      {
        "@type": "Question",
        "name": "Do you build websites that rank on Google in Centurion?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Every professional website RDS Studio builds includes on-page SEO, fast load speeds, mobile-first design, structured data markup, proper heading structure, and meta optimisation — all factors Google uses to rank websites. We also offer ongoing SEO services from R4,500/month to actively improve your Google rankings in Centurion and across South Africa."
        }
      }
    ]
  }

  const personSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://rdsstudio.co.za/#team",
    "name": "RDS Studio Team",
    "description": "Experienced digital marketing professionals specializing in web development, SEO, and cloud infrastructure. Our team combines technical expertise with strategic thinking to deliver measurable results for South African businesses.",
    "memberOf": {
      "@id": "https://rdsstudio.co.za/#organization"
    },
    "knowsAbout": [
      "Web Development",
      "WordPress Development",
      "React Development",
      "Digital Marketing Strategy",
      "Technical SEO Optimization",
      "Google Ads Management",
      "Social Media Marketing",
      "Private Cloud Infrastructure",
      "Node.js Development",
      "JavaScript & Modern Frameworks",
      "HTML/CSS & Responsive Design",
      "WooCommerce E-commerce",
      "UI/UX Design",
      "Server Administration"
    ],
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Centurion",
      "addressRegion": "Gauteng",
      "addressCountry": "ZA"
    },
    "url": "https://rdsstudio.co.za/about",
    "email": "info@rdsstudio.co.za"
  }

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://rdsstudio.co.za/#localbusiness",
    "additionalType": "https://www.wikidata.org/wiki/Q15618652",
    "name": "RDS Studio",
    "image": "https://rdsstudio.co.za/images/logo/og-image.png",
    "url": "https://rdsstudio.co.za",
    "telephone": "+27846390621",
    "email": "info@rdsstudio.co.za",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Centurion",
      "addressLocality": "Centurion",
      "addressRegion": "Gauteng",
      "postalCode": "0157",
      "addressCountry": "ZA"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "-25.8601",
      "longitude": "28.1890"
    },
    "areaServed": [
      { "@type": "City", "name": "Centurion" },
      { "@type": "City", "name": "Pretoria" },
      { "@type": "City", "name": "Midrand" },
      { "@type": "City", "name": "Johannesburg" },
      { "@type": "City", "name": "Irene" },
      { "@type": "City", "name": "The Reeds" },
      { "@type": "City", "name": "Lyttelton" },
      { "@type": "City", "name": "Highveld" },
      { "@type": "State", "name": "Gauteng" },
      { "@type": "Country", "name": "South Africa" }
    ],
    "priceRange": "$$",
    "description": "Top-rated web design agency in Centurion, Gauteng. Custom WordPress websites, SEO, Google Ads & digital marketing. Serving Centurion, Pretoria, Midrand & across Gauteng since 2014.",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Digital Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Web Design",
            "description": "Custom website design and development for businesses in Centurion and Gauteng"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Digital Marketing",
            "description": "Google Ads, social media advertising, and content marketing services"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "SEO Optimization",
            "description": "Search engine optimization to improve rankings and organic traffic"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Custom CMS & WordPress Integration",
            "description": "Bespoke content management systems with Blog Manager linked to WordPress for one-click publishing"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "WordPress Development",
            "description": "Custom WordPress themes, plugins, and WooCommerce solutions"
          }
        }
      ]
    },
    "knowsAbout": [
      "Web Design",
      "Digital Marketing",
      "SEO Optimization",
      "WordPress Development",
      "React Development",
      "Node.js",
      "Google Ads",
      "Private Cloud",
      "WooCommerce",
      "Responsive Design",
      "Custom CMS Development",
      "WordPress REST API Integration"
    ],
    "slogan": "Professional Web Design Agency in Centurion | WordPress, SEO & Google Ads",
    "openingHours": "Mo-Fr 09:00-18:00",
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
      "opens": "09:00",
      "closes": "18:00"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "47",
      "bestRating": "5",
      "worstRating": "1"
    },
    "sameAs": [
      "https://www.facebook.com/profile.php?id=61579996723546",
      "https://www.instagram.com/rdsstudio1111/",
      "https://www.linkedin.com/in/jean-pierre-matthys-du-toit-7671493a3/",
      "https://www.youtube.com/channel/UCqEgC_kMwk4MqEcIC_yCayw"
    ]
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(personSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  )
}

export default StructuredData
